export function createDiasCredito() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    Dias: 0,
    ClaveErp: '',
    EsActivo: true
  };
}
